/* eslint react/no-direct-mutation-state: "off", eqeqeq: "off", no-unused-vars: "off" */
import React, { Component } from 'react';
import { Row, Col, Button, FormGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import '../../../../../../Assets/EnsembleStyles/EnsCreateTenant.css';
import {FaQuestionCircle} from 'react-icons/fa';
import { setRoute, SaveComapnyDetailsforclient } from '../../../../../../action/manageTenantAction';
import Currencies from '../../../../../../Resources/Currencies';
import ErrorGif from '../../../../../../Assets/images/Error.gif';
import { makeGetCall } from '../../../../../../action/tenantAction';
import { getAllResources } from '../../../../../../action/cultureAction';


class CreateCompanyInformation extends Component {
    componentDidMount(){
        if(this.props.getLabels["ManageTenants.Create.Text"] === undefined){
            this.props.getAllResources();
        }
        if(this.props.ClientSideComapnyState != undefined && this.props.ClientSideComapnyState != null){
            let Data = this.props.ClientSideComapnyState;
            this.refs.New_Tenant_Name.value = Data.TenantName;
            this.refs.Tenant_Billing_Address.value = Data.Address;
            this.refs.Tenant_Billing_Email.value = Data.InvoiceEmail;
            this.refs.Tenant_Contact_Address.value = Data.ContactPhone;
            this.refs.Billing_Currency_Input.options.selectedIndex = Data.CurrencyId;
            document.getElementById('AfterHours').checked = Data.HasAfterHrs;
            document.getElementById('MeterCharges').checked = Data.HasMeter;
            document.getElementById('FixedRateCharges').checked = Data.HasFixedRate;
            this.state.routeModules['AfterHours'] = Data.HasAfterHrs;
            this.state.routeModules['MeterCharges'] = Data.HasMeter;
            this.state.routeModules['FixedRateCharges'] = Data.HasFixedRate;
        }
    }
    constructor(props) {
        super(props);
        this.state = {
            routeModules: {
                                AfterHours: false,
                                MeterCharges: false,
                                FixedRateCharges: false,
                                nextModule: ""
                            },
            redirect:  false,
            redirectHome: false,
            IsModalClose:false,
            IsDuplicateTenantName:false,
            IsEmptyTenantName:false,
            IsInvalidEmail:false,
        }
        this.toggle = this.toggle.bind(this);
        this.goNext = this.goNext.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    toggle (e) { this.state.routeModules[e.target.id] = e.target.checked;} 
    goBack (){
        this.setState({redirectHome: true});
    }
    goNext () {
        let Error_Msg;  //eslint-disable-line
        this.props.setRoute(this.state.routeModules);
        this.setState({IsModalClose: false, IsDuplicateTenantName: false, IsEmptyTenantName: false, IsInvalidEmail: false});
        Error_Msg = 'Error: You left necessary fields blank or entered invalid values.'
        let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let IsValid = true;
        
        let Tenant_Name = this.refs.New_Tenant_Name.value;
        let Billing_Addrs = this.refs.Tenant_Billing_Address.value;
        let Billing_Email = this.refs.Tenant_Billing_Email.value.trim();
        let Contact_Addrs = this.refs.Tenant_Contact_Address.value;
        
        if(Tenant_Name == null || Tenant_Name == ""){
            IsValid = false;
            this.setState({IsModalClose: true, IsEmptyTenantName: true});
        }
        if(Billing_Email != null && Billing_Email != ""){
            if(!Billing_Email.match(Email)){
                IsValid = false;
                this.setState({IsModalClose: true, IsInvalidEmail: true});
            }  
        }
        if(this.props.manageTenantsParams != undefined && this.props.manageTenantsParams.TenantsList != null){
            let lstTenants = this.props.manageTenantsParams.TenantsList;
            if(lstTenants != undefined && lstTenants.length > 0){
            lstTenants = lstTenants.filter(function(item){
                return Tenant_Name.toUpperCase() == item.tenantName.toUpperCase()
            });
            if(lstTenants != null && lstTenants.length > 0){
                Error_Msg = 'Error: Duplicate Tenant Name.';
                IsValid = false;
                this.setState({IsModalClose: true, IsDuplicateTenantName: true});
            }
            }
        }
        
        
        let Currency_Id = this.refs.Billing_Currency_Input.options.selectedIndex; 
        let Currency = this.refs.Billing_Currency_Input.options[Currency_Id].value;
        var data = {
            "TenantName"  : Tenant_Name,
            "Address"  : Billing_Addrs,
            "InvoiceEmail"  : Billing_Email,
            "ContactPhone"  : Contact_Addrs,
            "CurrencyId" : Currency_Id,
            "Currency" : Currency,
            "HasAfterHrs": this.state.routeModules.AfterHours,
            "HasMeter": this.state.routeModules.MeterCharges,
            "HasFixedRate": this.state.routeModules.FixedRateCharges
        }
        if(IsValid){
            this.setState({redirect: true});
            this.props.SaveComapnyDetailsforclient(data);
        }
    }

    
    
    render(manageTenantsParams, ClientSideComapnyState,getLabels) {
        let label = this.props.getLabels;
        if (this.state.redirect) {
            let routes = this.state.routeModules
            for (let key in routes){
                if (routes[key]) {
                    switch(key)
                     {
                         case "AfterHours": return <Redirect to={"/managetenant/BuildingSubgroups"} />;
                         case "MeterCharges": return <Redirect to={"/managetenant/TenantMeters"} />;
                         case "FixedRateCharges": return <Redirect to={"/managetenant/TenantFixedCharges"} />;
                         default: return <Redirect to={"/managetenant/ConfirmTenantSettings"} />;
                     }
                }
            }
            if(!this.state.routeModules.AfterHours && !this.state.routeModules.MeterCharges && !this.state.routeModules.FixedRateCharges)
                return <Redirect to={"/managetenant/ConfirmTenantSettings"} />
        }
        if(this.state.redirectHome){
            return <Redirect to={"/managetenant"} />
        }
        if(this.state.IsModalClose){
            var errormsg = <p  className="error_msg">
                            <img src={ErrorGif} alt="Trane Logo" /> 
                            {label['CheckTemperatureAdjustment.Text']}
                            </p> 
        }

        //Fetching and displaying list of currencies from Resources and appending it to the select option
        let CurrencyoptionsList = null;
        CurrencyoptionsList=  Currencies.EntireCurrenciesList().map((el, index) => ( <option id={index}>{el}</option> ));
        return (
            <div className="EnsembleCreateTenant">

                 <Row>
                 <Col sm={{size: 1, offset: 11 }} className="text-right" >
                 <FaQuestionCircle className="Ensemble_Icon Ensemble_question_Icon" />
                 </Col>
                 </Row>
                 <h4 className="form_title">{label['ManageTenants.Create.Text']}</h4>
               <div className="Customised_form_div">
               {errormsg}
               <legend className="form_sub_title">{label['CreateTenant.TenantInformation.Text']}</legend>

               <div className="form_group ">
               <Label className="Custom_label">{label['CreateTenant.Name.Text']}</Label>
               <input ref='New_Tenant_Name' id="create_tenant_name" className="custom_input default-input" maxLength="50"/>
               <span className="ErrorMark" hidden={!this.state.IsDuplicateTenantName && !this.state.IsEmptyTenantName}>!</span> 
               </div>

               <div className="form_group form_group_textarea">
               <Label className="Custom_label">{label['CreateTenant.Address.Text']}</Label>
               <textarea className="custom_input default-input" id="create_tenant_billingaddress" ref='Tenant_Billing_Address' rows="4" />
               
               </div>
               <div className="clear">&nbsp;</div>
               <div className="clear">&nbsp;</div>
               <div className="form_group">
               <Label className="Custom_label">{label['CreateTenant.InvoiceEmail.Text']}</Label>
               <input className=" custom_input default-input" type="text" id="create_tenant_email" ref='Tenant_Billing_Email'  />
               <span className="ErrorMark" hidden={!this.state.IsInvalidEmail}>!</span> 
               </div>
               <div className="clear">&nbsp;</div>
             <div className="form_group form_group_textarea">
               <Label className="Custom_label">{label['CreateTenant.ContactInfo.Text']}</Label>
               <textarea className="custom_input default-input" id="create_tenant_contactaddress" ref='Tenant_Contact_Address' rows="3" />
               </div>
             <div className="clear">&nbsp;</div>
               
             <legend className="form_sub_title">{label['CreateTenant.BillingOptions.Text']}</legend>

            
               <div className="form_group ">
               <Label className="Custom_label_small_width">{label['CreateTenant.lblBillingCurrency.Text']}</Label>
               <select ref='Billing_Currency_Input' style={{"fontFamily":"Arial"}} className="Modal_input_regular"  id="create_tenant_currency" >
                    {CurrencyoptionsList}
               </select>
               </div>
          
              
                    <div className="form_group form_group_textare">
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" id="AfterHours" onChange={this.toggle} />{' '}
                                    {label['CreateTenant.chkAfterHourBilling.Text'] !== undefined ? label['CreateTenant.chkAfterHourBilling.Text'] : "Track for After-Hours Requests for Billing"} 
                                      </Label>
                        </FormGroup>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" id="MeterCharges" onChange={this.toggle} />{' '}
                                {label['CreateTenant.chkMeterObjectBilling.Text'] !== undefined ? label['CreateTenant.chkMeterObjectBilling.Text'] : "Enable Meter Charges"} 
                                     </Label>
                        </FormGroup>
                        <FormGroup check disabled>
                            <Label check>
                                <Input type="checkbox" id="FixedRateCharges" onChange={this.toggle} />{' '}
                                {label['CreateTenant.chkFixedBilling.Text'] !== undefined ? label['CreateTenant.chkFixedBilling.Text'] : "Enable Fixed Rate Charges"}
                                    </Label>
                        </FormGroup>
                    </div>
                    <FormGroup row className="btns_group">
                        <Col sm={{ size: 10 }}>
                        
                            <Button className="btn-gray btn-md" onClick={this.goBack} id="create_tenant_back"> {label['Wizards.BackButton.Text']}</Button>
                            <Button className="btn-success btn-md" onClick={this.goNext} id="create_tenant_next" >{label['Wizards.NextButton.Text']}</Button>
                        </Col>
                    </FormGroup>
               </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
        manageTenantsParams: state.tenantsRootReducer,
        ClientSideComapnyState: state.manageTenant.ClientSideComapnyData,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference
    };
};

const mapDispatchToProps = dispatch => {
    return {
        makeGetCall: () => dispatch(makeGetCall()),
        setRoute: (params) => dispatch(setRoute(params)),
        SaveComapnyDetailsforclient: (data) => dispatch(SaveComapnyDetailsforclient(data)),
        getAllResources: () => dispatch(getAllResources())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompanyInformation)